<script setup>
import axios from 'axios'
import { onMounted } from 'vue'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const addAccessCount = async() => {
  await axios.post("./php/addAccessCounter.php")
  .then((response) => {
    // OK
    console.log(response)
  })
}

onMounted(() => {
  addAccessCount()
})
</script>

<template>
  <nav>
    <a href="//tohoku-washigumi.com/">
      <span class="css__title">鷲組!!</span>
    </a>
    <div>東北楽天ゴールデンイーグルスファン集いの場</div>

    <div style="margin: 2em 0;">
      <a href="//tohoku-washigumi.com/agreement">利用規約</a>
      <a href="//tohoku-washigumi.com/privacy_policy">プライバシーポリシー</a>
      <a href="//tohoku-washigumi.com/contact">問い合わせ</a>
    </div>

    <p style="margin-top: 3em;">Copyright © 鷲組!! All Rights Reserved.</p>
  </nav>
</template>

<style scoped>
nav {
  text-align: center;
  color: #f3f3f2;
}

a {
  display: inline-block;
  margin: 0 1em;
  color: #f3f3f2;
  text-decoration: none;
  white-space: nowrap;
}

.css__title {
  margin: 0;
  font-weight: bolder;
  font-size: 2.5em;
}
</style>